import React from 'react';
import styled from 'styled-components';
import Box from 'react-raster';
import { Copy } from '../Typography';
import Container, { getGridBottomFromContent } from '../Container';

const Content = styled(Copy)`
  blockquote {
    float: none;
    color: ${({ theme }) => theme.colours.blue};
    font-family: ${({ theme }) => theme.fontFamilyBold};
    font-weight: 700;
    font-style: normal;
    font-size: 24px;
    line-height: 115%;
    letter-spacing: -1px;
    width: 100%;

    @media (${({ theme }) => theme.mq.m}) {
      float: right;
      font-size: 32px;
      width: 300px;
      padding: 0 20px;
    }
  }
`;

function Paragraph({ paragraph, bottomSpacing }) {
  return (
    <Container
      marginBottom={getGridBottomFromContent(bottomSpacing)}
      gridRowGap={0}
    >
      <Box cols={[6, 9]}>
        <Content>{paragraph}</Content>
      </Box>
    </Container>
  );
}

export default Paragraph;
